// extracted by mini-css-extract-plugin
module.exports = {"disconnectPopupWrapper":"MobileDisconnectOverlay_disconnectPopupWrapper__2eqZp"};